/**
 * @ngdoc services
 * @memberof mercury.services.tax
 * @name salestax
 * @description Service for accessing the selected reporting period
 */
angular.module('mercury.services.tax')
.factory('SalesTax', ["$resource", "$http", "userinfo", "settings", function($resource, $http, userinfo, settings) {
  var CompanyTaxes = $resource(settings.apiHost + '/r/CompanySalesTax/');

  // Wrapper for our "old" way or returning resources, so we can insert into older controllers
  // without needing to rewrite the loader
  function getLocaleSalesTaxAmountsRes(countryCode, provinceCode) {
    return CompanyTaxes.query({countryCode: countryCode, provinceCode: provinceCode});
  }

  function getLocaleSalesTaxAmounts(countryCode, provinceCode) {
    return getLocaleSalesTaxAmountsRes(countryCode, provinceCode).$promise;
  }

  function getCompanySalesTaxAmounts(companyId) {
    if (!angular.isDefined(companyId)) {
      companyId = userinfo.activeCompany();
    }
    return $http.get(settings.apiHost + '/r/CompanySalesTax/', {companyId: companyId}, {headers: {'x-loaded-company-id': companyId}});
  }

  function setCompanySalesTaxAmounts(companyId, taxRates) {
    return $http.post(settings.apiHost + '/r/CompanySalesTax/', {companyId: companyId, rates: taxRates}, {headers: {'x-loaded-company-id': companyId}});
  }

  function getCompanySalesTaxRate(salesTaxRates, salesTaxRateId) {
    var salesTaxRate = salesTaxRates.data.find(function(salesTaxRate) {
      return salesTaxRate.rate === salesTaxRateId;
    });
    return salesTaxRate != null ? salesTaxRate.amount + 1 : 1.15;
  }

  return {
    getLocaleSalesTaxAmounts: getLocaleSalesTaxAmounts,
    getLocaleSalesTaxAmountsRes: getLocaleSalesTaxAmountsRes,
    getCompanySalesTaxAmounts: getCompanySalesTaxAmounts,
    setCompanySalesTaxAmounts: setCompanySalesTaxAmounts,
    getCompanySalesTaxRate: getCompanySalesTaxRate
  };
}]);
